import MonitoringMain from "@/views/monitoring/views/MonitoringMain.vue";
import AttendanceRoute from "@/views/monitoring/views/attendance/router/attendance.route";
import ViaticRoute from "@/views/monitoring/views/viatic/router/viatic.route.js";
import ReportsRoute from "@/views/monitoring/views/reports/router/reports.route.js";
import DiasLibresRoute from "@/views/monitoring/views/dias-libres/router/dias-libres.route.js";

const routes = [
    {
        path: "/monitoring",
        name: "monitoring",
        redirect: { name: "monitoring-attendance" },
        meta: { module: 10 },
        component: MonitoringMain,
        children: [
            ...AttendanceRoute,
            ...ViaticRoute,
            ...ReportsRoute,
            ...DiasLibresRoute,
        ]
    }
];

export default routes;